export const theme = {
  token: {
    colorPrimary: '#e74c3c',
    colorSuccess: '#52c41a',
    colorWarning: '#f39c12',
    colorError: '#e74c3c',
    colorInfo: '#3498db',
    colorTextBase: '#1a1a1a',
    colorBgBase: '#ffffff',
    borderRadius: 4,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
};

export const colors = {
  primary: '#e74c3c',
  secondary: '#f39c12',
  dark: '#1a1a1a',
  darkBg: '#0f0f0f',
  white: '#ffffff',
  gray: {
    100: '#f8f9fa',
    200: '#e9ecef',
    300: '#dee2e6',
    400: '#ced4da',
    500: '#adb5bd',
    600: '#6c757d',
    700: '#495057',
    800: '#343a40',
    900: '#212529',
  }
};